// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/**
 * UpdateNotification Styles
 *
 * Modern, non-intrusive notification banner for application updates.
 * Uses gradient background, smooth animations, and responsive design.
 */

.update-notification {
  position: fixed;
  top: 24px;
  left: 50%;
  transform: translateX(-50%);
  z-index: 10000;
  width: min(884px, calc(100% - 48px));
  animation: slideDown 0.4s cubic-bezier(0.16, 1, 0.3, 1);
  pointer-events: auto;
}

/* Slide down animation */
@keyframes slideDown {
  from {
    transform: translate(-50%, -120px);
    opacity: 0;
  }
  to {
    transform: translate(-50%, 0);
    opacity: 1;
  }
}

.update-notification__content {
  position: relative;
  display: flex;
  align-items: center;
  gap: 32px;
  padding: 16px 32px;
  border-radius: 16px;
  background: linear-gradient(
    26deg,
    #000000 0%,
    #4a4a4a 34%,
    #de4858 100%
  );
  color: #ffffff;
  box-shadow: 0 10px 40px rgba(0, 0, 0, 0.25);
}

.update-notification__icon {
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 60px;
  height: 60px;
  color: #ffffff;
  animation: rotate 2s linear infinite;
}

@keyframes rotate {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}

.update-notification__text {
  flex: 1;
  min-width: 0;
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.update-notification__title {
  margin: 0;
  font-size: 24px;
  font-weight: 600;
  line-height: 1.5;
  letter-spacing: -0.01em;
  font-family: 'Noto Sans', 'SF Pro Text', 'Segoe UI', sans-serif;
  overflow-wrap: break-word;
}

.update-notification__description {
  margin: 0;
  font-size: 16px;
  line-height: 1.36;
  font-weight: 400;
  font-family: 'Noto Sans', 'SF Pro Text', 'Segoe UI', sans-serif;
  overflow-wrap: break-word;
}

.update-notification__current-version {
  font-weight: 400;
}

.update-notification__actions {
  display: flex;
  align-items: center;
  gap: 12px;
  flex-shrink: 0;
}

.update-notification__button {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  height: 45px;
  padding: 0 16px;
  border-radius: 10px;
  border: none;
  cursor: pointer;
  font-weight: 600;
  font-size: 16px;
  line-height: 1.5;
  letter-spacing: -0.01em;
  transition: all 0.2s ease-in-out;
  white-space: nowrap;
  font-family: 'SF Pro Text', 'Noto Sans', 'Segoe UI', sans-serif;
}

.update-notification__button:focus-visible {
  outline: 2px solid rgba(255, 255, 255, 0.6);
  outline-offset: 2px;
}

.update-notification__button--primary {
  background: #de4858;
  color: #ffffff;
}

.update-notification__button--primary:hover {
  filter: brightness(1.05);
}

.update-notification__button--secondary {
  background: transparent;
  color: #ffffff;
  border: 2px solid rgba(255, 255, 255, 0.8);
}

.update-notification__button--secondary:hover {
  background: rgba(255, 255, 255, 0.12);
}

/* Responsive design for mobile */
@media (max-width: 640px) {
  .update-notification {
    top: 16px;
    width: min(100%, calc(100% - 32px));
  }

  .update-notification__content {
    flex-direction: column;
    align-items: stretch;
    gap: 16px;
    padding: 16px 20px;
  }

  .update-notification__actions {
    flex-direction: column;
    width: 100%;
  }

  .update-notification__button {
    width: 100%;
  }
}

/* Very small screens */
@media (max-width: 400px) {
  .update-notification__content {
    text-align: center;
    gap: 16px;
  }
}

/* Accessibility: Reduced motion */
@media (prefers-reduced-motion: reduce) {
  .update-notification {
    animation: fadeIn 0.3s ease-in;
  }

  @keyframes fadeIn {
    from {
      opacity: 0;
    }
    to {
      opacity: 1;
    }
  }

  .update-notification__icon {
    animation: none;
  }

  .update-notification__button {
    transition: none;
  }
}

/* Dark mode support (if your app has dark mode) */
@media (prefers-color-scheme: dark) {
  .update-notification__content {
    background: linear-gradient(135deg, #4a5568 0%, #2d3748 100%);
    border: 1px solid rgba(255, 255, 255, 0.2);
  }

  .update-notification__button--primary {
    background: #e2e8f0;
    color: #2d3748;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/UpdateNotification/UpdateNotification.css"],"names":[],"mappings":"AAAA;;;;;EAKE;;AAEF;EACE,eAAe;EACf,SAAS;EACT,SAAS;EACT,2BAA2B;EAC3B,cAAc;EACd,oCAAoC;EACpC,uDAAuD;EACvD,oBAAoB;AACtB;;AAEA,yBAAyB;AACzB;EACE;IACE,kCAAkC;IAClC,UAAU;EACZ;EACA;IACE,6BAA6B;IAC7B,UAAU;EACZ;AACF;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,mBAAmB;EACnB;;;;;GAKC;EACD,cAAc;EACd,2CAA2C;AAC7C;;AAEA;EACE,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,cAAc;EACd,oCAAoC;AACtC;;AAEA;EACE;IACE,uBAAuB;EACzB;EACA;IACE,yBAAyB;EAC3B;AACF;;AAEA;EACE,OAAO;EACP,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,uBAAuB;EACvB,+DAA+D;EAC/D,yBAAyB;AAC3B;;AAEA;EACE,SAAS;EACT,eAAe;EACf,iBAAiB;EACjB,gBAAgB;EAChB,+DAA+D;EAC/D,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,cAAc;AAChB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,eAAe;EACf,mBAAmB;EACnB,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,uBAAuB;EACvB,gCAAgC;EAChC,mBAAmB;EACnB,+DAA+D;AACjE;;AAEA;EACE,2CAA2C;EAC3C,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,uBAAuB;EACvB,cAAc;EACd,0CAA0C;AAC5C;;AAEA;EACE,qCAAqC;AACvC;;AAEA,iCAAiC;AACjC;EACE;IACE,SAAS;IACT,mCAAmC;EACrC;;EAEA;IACE,sBAAsB;IACtB,oBAAoB;IACpB,SAAS;IACT,kBAAkB;EACpB;;EAEA;IACE,sBAAsB;IACtB,WAAW;EACb;;EAEA;IACE,WAAW;EACb;AACF;;AAEA,uBAAuB;AACvB;EACE;IACE,kBAAkB;IAClB,SAAS;EACX;AACF;;AAEA,kCAAkC;AAClC;EACE;IACE,8BAA8B;EAChC;;EAEA;IACE;MACE,UAAU;IACZ;IACA;MACE,UAAU;IACZ;EACF;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,gBAAgB;EAClB;AACF;;AAEA,kDAAkD;AAClD;EACE;IACE,6DAA6D;IAC7D,0CAA0C;EAC5C;;EAEA;IACE,mBAAmB;IACnB,cAAc;EAChB;AACF","sourcesContent":["/**\n * UpdateNotification Styles\n *\n * Modern, non-intrusive notification banner for application updates.\n * Uses gradient background, smooth animations, and responsive design.\n */\n\n.update-notification {\n  position: fixed;\n  top: 24px;\n  left: 50%;\n  transform: translateX(-50%);\n  z-index: 10000;\n  width: min(884px, calc(100% - 48px));\n  animation: slideDown 0.4s cubic-bezier(0.16, 1, 0.3, 1);\n  pointer-events: auto;\n}\n\n/* Slide down animation */\n@keyframes slideDown {\n  from {\n    transform: translate(-50%, -120px);\n    opacity: 0;\n  }\n  to {\n    transform: translate(-50%, 0);\n    opacity: 1;\n  }\n}\n\n.update-notification__content {\n  position: relative;\n  display: flex;\n  align-items: center;\n  gap: 32px;\n  padding: 16px 32px;\n  border-radius: 16px;\n  background: linear-gradient(\n    26deg,\n    #000000 0%,\n    #4a4a4a 34%,\n    #de4858 100%\n  );\n  color: #ffffff;\n  box-shadow: 0 10px 40px rgba(0, 0, 0, 0.25);\n}\n\n.update-notification__icon {\n  flex-shrink: 0;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 60px;\n  height: 60px;\n  color: #ffffff;\n  animation: rotate 2s linear infinite;\n}\n\n@keyframes rotate {\n  from {\n    transform: rotate(0deg);\n  }\n  to {\n    transform: rotate(360deg);\n  }\n}\n\n.update-notification__text {\n  flex: 1;\n  min-width: 0;\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n}\n\n.update-notification__title {\n  margin: 0;\n  font-size: 24px;\n  font-weight: 600;\n  line-height: 1.5;\n  letter-spacing: -0.01em;\n  font-family: 'Noto Sans', 'SF Pro Text', 'Segoe UI', sans-serif;\n  overflow-wrap: break-word;\n}\n\n.update-notification__description {\n  margin: 0;\n  font-size: 16px;\n  line-height: 1.36;\n  font-weight: 400;\n  font-family: 'Noto Sans', 'SF Pro Text', 'Segoe UI', sans-serif;\n  overflow-wrap: break-word;\n}\n\n.update-notification__current-version {\n  font-weight: 400;\n}\n\n.update-notification__actions {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  flex-shrink: 0;\n}\n\n.update-notification__button {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  height: 45px;\n  padding: 0 16px;\n  border-radius: 10px;\n  border: none;\n  cursor: pointer;\n  font-weight: 600;\n  font-size: 16px;\n  line-height: 1.5;\n  letter-spacing: -0.01em;\n  transition: all 0.2s ease-in-out;\n  white-space: nowrap;\n  font-family: 'SF Pro Text', 'Noto Sans', 'Segoe UI', sans-serif;\n}\n\n.update-notification__button:focus-visible {\n  outline: 2px solid rgba(255, 255, 255, 0.6);\n  outline-offset: 2px;\n}\n\n.update-notification__button--primary {\n  background: #de4858;\n  color: #ffffff;\n}\n\n.update-notification__button--primary:hover {\n  filter: brightness(1.05);\n}\n\n.update-notification__button--secondary {\n  background: transparent;\n  color: #ffffff;\n  border: 2px solid rgba(255, 255, 255, 0.8);\n}\n\n.update-notification__button--secondary:hover {\n  background: rgba(255, 255, 255, 0.12);\n}\n\n/* Responsive design for mobile */\n@media (max-width: 640px) {\n  .update-notification {\n    top: 16px;\n    width: min(100%, calc(100% - 32px));\n  }\n\n  .update-notification__content {\n    flex-direction: column;\n    align-items: stretch;\n    gap: 16px;\n    padding: 16px 20px;\n  }\n\n  .update-notification__actions {\n    flex-direction: column;\n    width: 100%;\n  }\n\n  .update-notification__button {\n    width: 100%;\n  }\n}\n\n/* Very small screens */\n@media (max-width: 400px) {\n  .update-notification__content {\n    text-align: center;\n    gap: 16px;\n  }\n}\n\n/* Accessibility: Reduced motion */\n@media (prefers-reduced-motion: reduce) {\n  .update-notification {\n    animation: fadeIn 0.3s ease-in;\n  }\n\n  @keyframes fadeIn {\n    from {\n      opacity: 0;\n    }\n    to {\n      opacity: 1;\n    }\n  }\n\n  .update-notification__icon {\n    animation: none;\n  }\n\n  .update-notification__button {\n    transition: none;\n  }\n}\n\n/* Dark mode support (if your app has dark mode) */\n@media (prefers-color-scheme: dark) {\n  .update-notification__content {\n    background: linear-gradient(135deg, #4a5568 0%, #2d3748 100%);\n    border: 1px solid rgba(255, 255, 255, 0.2);\n  }\n\n  .update-notification__button--primary {\n    background: #e2e8f0;\n    color: #2d3748;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
